/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { policyLanguageBodySchema } from "./policyLanguageBodySchema.ts";
import { z } from "zod";

export const policyLanguageModelSchema = z.object({
    "language": z.array(z.lazy(() => policyLanguageBodySchema)).describe("Список языков")
    })